export const SELECT_REFERENCE_SOURCE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "50%",
  },
  {
    title: "Scope",
    key: "reference_source_scope",
    dataIndex: "reference_source_scope",
    width: "25%",
  },
  {
    title: "Type",
    key: "reference_source_type",
    dataIndex: "reference_source_type",
    width: "25%",
  },
];

export const SELECT_REFERENCE_SOURCE_ROW = [
  { id: 1, name: "aaCPT/HCPCS Codes", scope: "Public", type: "Industry" },
  { id: 1, name: "RDS Sex", scope: "Public", type: "Industry" },
  { id: 1, name: "RDS Procedures", scope: "Public", type: "Industry" },
  { id: 1, name: "RDS Specialities", scope: "Public", type: "Industry" },
  { id: 1, name: "RDS Languages", scope: "Public", type: "Industry" },
];
